import NewPunchOverlay from 'components/Overlays/NewPunchOverlay';
import CreateRFIOverlay from 'components/Overlays/RFIOverlays/CreateRFIOverlay';
import ViewRFIOverlay from 'components/Overlays/RFIOverlays/ViewRFIOverlay';
import AddSubmittalOverlay from 'components/Overlays/SubmittalOverlays/AddSubmittalOverlay';
import AssignSubmittalOverlay from 'components/Overlays/SubmittalOverlays/AssignSubmittalOverlay';
import EditSubmittalOverlay from 'components/Overlays/SubmittalOverlays/EditSubmittalOverlay';
import RespondToSubmittalOverlay from 'components/Overlays/SubmittalOverlays/RespondToSubmittalOverlay';
import ReviewSubmittalOverlay from 'components/Overlays/SubmittalOverlays/ReviewSubmittalOverlay';
import UpdateMultipleSubmittalsOverlay from 'components/Overlays/SubmittalOverlays/UpdateMultipleSubmittalsOverlay';
import ViewSubmittalOverlay from 'components/Overlays/SubmittalOverlays/ViewSubmittalOverlay';
import UpdateMultipleDrawingsOverlay from 'components/Overlays/UpdateMultipleDrawingsOverlay';
import UpdateMultiplePubReqOverlay from 'components/Overlays/UpdateMultiplePubReqOverlay';
import UpdateMultiplePunchOverlay from 'components/Overlays/UpdateMultiplePunchOverlay';
import UpdatePunchOverlay from 'components/Overlays/UpdatePunchOverlay';
import ViewPunchListOverlay from 'components/Overlays/ViewerOverlays/ViewPunchListOverlay';
import ViewRFIListOverlay from 'components/Overlays/ViewerOverlays/ViewRFIListOverlay';
import ViewMapLayersOverlay from 'components/Overlays/ViewMapLayersOverlay/ViewMapLayersOverlay';
import Immutable from 'immutable';
import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

const overlayInteractionTypes = Immutable.List([
  'CreatePunch',
  'UpdatePunch',
  'UpdateMultipleDrawings',
  'UpdateMultiplePunches',
  'UpdateMultiplePubReq',
  'UpdateMultipleSubmittals',
  'CreateRFI',
  'ViewRFI',
  'AddSubmittal',
  'ViewSubmittal',
  'EditSubmittal',
  'RespondToSubmittal',
  'ViewPunchList',
  'ViewMapPunchList',
  'AssignSubmittal',
  'ReviewSubmittal',
  'ViewMapLayers',
  'ViewRFIList',
]);

interface OverlayComponents {
  [key: string]: typeof React.Component | React.FunctionComponent<any>;
}

const overlayComponents: OverlayComponents = {
  CreatePunch: NewPunchOverlay,
  UpdatePunch: UpdatePunchOverlay,
  UpdateMultipleDrawings: UpdateMultipleDrawingsOverlay,
  UpdateMultiplePunches: UpdateMultiplePunchOverlay,
  UpdateMultiplePubReq: UpdateMultiplePubReqOverlay,
  UpdateMultipleSubmittals: UpdateMultipleSubmittalsOverlay,
  CreateRFI: CreateRFIOverlay,
  ViewRFI: ViewRFIOverlay,
  AddSubmittal: AddSubmittalOverlay,
  ViewSubmittal: ViewSubmittalOverlay,
  AssignSubmittal: AssignSubmittalOverlay,
  ReviewSubmittal: ReviewSubmittalOverlay,
  EditSubmittal: EditSubmittalOverlay,
  RespondToSubmittal: RespondToSubmittalOverlay,
  ViewPunchList: ViewPunchListOverlay,
  ViewMapPunchList: ViewPunchListOverlay,
  ViewMapLayers: ViewMapLayersOverlay,
  ViewRFIList: ViewRFIListOverlay,
};

class OverlayPortal extends React.Component<WithAppStoreProps> {
  render(): React.ReactNode {
    const { interactions } = this.props.appState;

    const interactionComponents = interactions
      .filter((i) => overlayInteractionTypes.some((t) => t === i.type))
      .map((i) => {
        const Component = overlayComponents[i.type];

        return <Component key={i.type} interaction={i} />;
      });

    return interactionComponents;
  }
}

export default withAppStore(OverlayPortal);
